export const supportedLanguages = ["en", "it"] as const;

type i18nlanguages = typeof supportedLanguages[number];
export type i18nForFields<TFieldName extends string, TType = string> = {
  [K in i18nlanguages & string as `${TFieldName}_${K}`]: TType;
};

export type WithI18n<TFields extends string, TType = string> = {
  i18n: Partial<i18nForFields<TFields, TType>>;
};
